module.exports = __webpack_public_path__ + "static/media/CT_2019_30446A.97b35a36.png";